import { render } from "./rich-editor.vue?vue&type=template&id=bc38b264&scoped=true&ts=true"
import script from "./rich-editor.vue?vue&type=script&lang=ts"
export * from "./rich-editor.vue?vue&type=script&lang=ts"

import "./rich-editor.vue?vue&type=style&index=0&id=bc38b264&scoped=true&lang=css"

import exportComponent from "E:\\vs2019\\face-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc38b264"]])

export default __exports__